import { simplePermissionType } from "src/components/Permissions/interface";
import IBaseDTO from "src/Interfaces/baseDTO";

export interface ISwot extends IBaseDTO{
    mes001Id: number,
    mes001Titulo: string,
    mes001Dtinicio: Date,
    mes001Dtfim: Date,
    mes001Taa011Id?: number,
    permissions?:Array<ISwotPermission>
    userPermission:simplePermissionType
}

export interface ISwotItem{
    id:string,
    mes002Id: number,
    mes002Mes001Id: number,
    mes001Titulo?: string,
    mes002Titulo: string,
    mes002Secao: SWOTType,
    mes002Importancia: number,
    mes002IntensidadeUrg: number,
    mes002Tendencia: number,
    mes002Pontuacao: number,
    mes002Identificador: string,
    mes002Taa011Id: number,
    dimensionText:string,
    hasBonds:boolean,
    onChange?:boolean,
    bonds?:ISwotItem[],
    traceability?: IAnalysisTraceability
}

export interface IAnalysisTraceability{
    maa001Descricao: string,
    maa001Label1: string,
    maa001Label2: string,
    maa001Label3: string,
    maa001Titulo: string,
    maa002Descricao: string,
    maa003Descricao: string,
    maa004Descricao: string,
    maa004Importancia: number,
    maa004Pontuacao: number,
    maa004Probabilidade: number,
    maa004Tendencia: number,
}

export interface ISwotPermission{
    mes004Id:number, 
    mes004Mes001Id:number, 
    mes004Efa004Id:number,
    mes004Efa005Id:number, 
    mes004Permissao:simplePermissionType, 
    efa005Nome: string,
    efa004Descricao: string,
}

export interface ISwotBond {
    mes005Id: number,
    mes005Mes002Id: number,
    mes005Mes002Id2: number
}

export interface IObjectiveItem extends ISwotBond{
    item1:ISwotItem;
    item2:ISwotItem;
}

export interface ISwotMatrix{
    swotId?:number;
    swotTitle?: string;
    filters?: IFiltersSwotPanel;
}

export interface ISwotItens{
    data: ISwotItem[];
    type: SWOTType;
    canChange: boolean;
    SWOTId?:number;
    swotTitle?: string;
    dimensionId: number;
}

export interface ISwotStrategies{
    swotId?: number,
    canChange?: boolean,
    filters?: IFiltersSwotPanel
}

export interface IMatrixPriorityItem{
    color: string,
    number: string,
    data: ISwotItem[],
    titles: {
      heading: any,
      title1: any
    }
}

export enum SWOTType {
    STRENGTHS  = 0,
    WEAKNESSES = 1,
    THREATS = 2, 
    OPPORTUNITIES = 3
}

export interface IRefSwotCrudModal {
    actionButtonAdd: (onClose?:(swot?:ISwot)=>void) => void;
    actionButtonChange: (id:number,duplicate:boolean,onClose?:(swot?:ISwot)=>void) => void;
    actionButtonDelete: (swot:{id:number,title:string},onClose?:(swot?:number)=>void) => void;
}

export interface IFiltersSwotPanel{
    f: string;
    startDate?: string | undefined;
    endDate?: string | undefined;
    map: string | undefined;
    perspective: string | undefined;
    objective: string | undefined;
}
